"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncTakeSorted = asyncTakeSorted;
exports.default = void 0;

var _heap = _interopRequireDefault(require("little-ds-toolkit/lib/heap"));

var _asyncIterable = require("../../internal/async-iterable");

var _compare = _interopRequireDefault(require("../../internal/compare"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

async function* asyncTakeSorted(source, n = Infinity, comparator = _compare.default) {
  const heap = new _heap.default(comparator);

  for await (const item of source) {
    heap.push(item);

    if (heap.size() > n) {
      heap.pop();
    }
  }

  const len = heap.size();

  for (let i = 0; i < len; i++) {
    yield heap.pop();
  }
}

var _default = (0, _asyncIterable.asyncIterableCurry)(asyncTakeSorted, {
  minArgs: 0,
  maxArgs: 2,

  validateArgs(args) {
    if (typeof args[1] === 'number') {
      args[0] = args[1];
      args[1] = undefined;
    }
  }

});

exports.default = _default;